<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <a-spin :spinning="spinning">
        <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="As of"><br>
                                <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Format" >
                                <select class="form-control" size="large" v-model="inputFormat" @click.prevent="autoDisable">
                                    <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" size="large" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select v-if="inputFormat == '1'" class="form-control" size="large" v-model="inputSortBy" @click.prevent="autoChange">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                                <select v-else class="form-control" size="large" v-model="inputSortExtendedBy" @click.prevent="autoChange">
                                    <option v-for="option in sortExtendedOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Display onhand">
                                <select class="form-control" size="large" v-model="inputDisplay">
                                    <option v-for="option in displayOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isShowPrev">
                        Show items with previous transactions
                    </base-checkbox>
                    <base-checkbox class="mb-3" v-model="isConsider" :disabled="inputFormat == '1'">
                        Consider Transfer In in Last Arrival
                    </base-checkbox>
                    <base-checkbox class="mb-3" v-model="isSeparateSite">
                        Separate per site
                    </base-checkbox>

                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
        </a-spin>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'

    import {
        mapState,
        mapActions
    } from 'vuex'
    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: moment().endOf('day'),
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'product_id',
                inputSortExtendedBy: 'product_id',
                sortOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'}
                ],
                sortExtendedOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'},
                    {key: 'rr_date', value: 'Last Arrival'},
                    {key: 'in_qty', value: 'Incoming Quantity'},
                    {key: 'out_qty', value: 'Outgoing Quantity'}
                ],
                inputFormat: '1',
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Extended'},
                    {key: '3', value: 'Extended with # of days since last sale'}
                ],
                inputDisplay: '1',
                displayOptions: [
                    {key: '1', value: 'All items regarless of onhand quantity'},
                    {key: '2', value: 'All items with onhand quantity only'},
                    {key: '3', value: 'All items with zero onhand quantity only'},
                    {key: '4', value: 'All items with negative onhand quantity only'},
                    {key: '5', value: 'All items with negative or zero onhand quantity'},
                    {key: '6', value: 'All items with positive or zero onhand quantity'},
                    {key: '7', value: 'All items except those with zero quantity'},
                ],
                isShowPrev: false,
                isConsider: false,
                isSeparateSite: false,
                birSalesReports: [],

                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                spinning: false,
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile','endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(this.inputFormat == '1'){
                    this.inputSortExtendedBy = this.inputSortBy
                } else {
                    if(e.target.value == 'product_id' || e.target.value == 'barcode' || e.target.value == 'name' || e.target.value == 'onhand_qty'){
                        this.inputSortBy = this.inputSortExtendedBy
                    } else {
                        this.inputSortBy = 'product_id'
                    }
                }
            },
            autoDisable(e){
                if(this.inputFormat == '1'){
                    this.isConsider = false
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            diffDays(date1, date2){
                let a = moment(date1,'YYYY-MM-DD');
                let b = moment(date2,'YYYY-MM-DD');
                return b.diff(a, 'days');
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let sorting = this.inputSortBy
                if(this.inputFormat != '1'){
                    sorting = this.inputSortExtendedBy
                }

                let as_of = this.inputDate.format('MMMM DD, YYYY')

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "isTI": this.isConsider,
                    "isFormat": this.inputFormat,
                    "isPrev": this.isShowPrev,
                    "advanced_filter": this.params
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = []
                    if(this.inputFormat == '1'){
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
                    }

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    let header_top = [];
                    let header_detail = [];
                    if(this.inputFormat == '1'){
                        header_top.push(
                            {content: 'PCode', styles: {halign: 'center'}},
                            {content: 'Barcode', styles: {halign: 'center'}},
                            {content: 'Stock #', styles: {halign: 'center'}},
                            {content: 'Ref Code', styles: {halign: 'center'}},
                            {content: 'Description', styles: {halign: 'center'}},
                            {content: 'On-Hand', styles: {halign: 'center'}}
                        )

                        headers = [header_top]
                    } else {
                        header_top.push(
                            {content: 'PCode', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Barcode', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Stock #', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Description', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'On-Hand', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Incoming', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Outgoing', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Available', rowSpan: 2, styles: {halign: 'center'}}
                        )

                        if(this.inputFormat == '3'){
                            header_top.push(
                                {content: '# of day/s\nsince last sale', rowSpan: 2, styles: {halign: 'center'}}
                            )
                        }

                        let arrival_header = 'Last Arrival (RR Document)'
                        if(this.isConsider == true){
                            arrival_header = 'Last Arrival (RR/STI Document)'
                        }
                        header_top.push(
                            {content: arrival_header, colSpan: 3, styles: {halign: 'center'}}
                        )

                        header_detail.push(
                            {content: 'Date', styles: {halign: 'center'}},
                            {content: 'Quantity', styles: {halign: 'center'}},
                            {content: 'Cost', styles: {halign: 'center'}}
                        )

                        headers = [header_top, header_detail]
                    }

                    // console.log("-------------------")
                    // console.log("headers",headers)

                    for(let x=0; x < siteSpecific.length; x++){
                        // console.log("siteSpecific",siteSpecific);
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0
                            let total_in_qty = 0
                            let total_out_qty = 0
                            let total_rr_qty = 0
                            let total_rr_cost = 0
                            let total_available = 0


                            let grand_onhand_qty = 0
                            let grand_in_qty = 0
                            let grand_out_qty = 0
                            let grand_rr_qty = 0
                            let grand_rr_cost = 0
                            let grand_available = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_name){
                                        let detail_header = [{content: grouper_name, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_name

                                let as_of_date = this.inputDate.format('YYYY-MM-DD')

                                let no_days_display = ''
                                if(reportLine.sales_date != null){
                                    let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                                    no_days_display = this.formatNumber(Number(no_days))
                                }

                                let rr_date = ''
                                let rr_qty = ''
                                let rr_cost = ''
                                if(reportLine.rr_date != null){
                                    rr_date = reportLine.rr_date
                                    rr_qty = this.convertToCurrency(Number(reportLine.rr_qty))
                                    rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                                }
                                let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)
                                let detail = [
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    reportLine.stock_no
                                ]
                                if(this.inputFormat == '1'){
                                    detail.push(reportLine.reference_code)
                                }
                                detail.push(
                                    {content: reportLine.name, styles: {halign: 'left'}},
                                    this.convertToCurrency(Number(reportLine.onhand_qty))
                                )
                                if(this.inputFormat != '1'){
                                    detail.push(
                                        this.convertToCurrency(Number(reportLine.in_qty)),
                                        this.convertToCurrency(Number(reportLine.out_qty)),
                                        this.convertToCurrency(available)
                                    )
                                }
                                if(this.inputFormat == '3'){
                                    detail.push(no_days_display)
                                }
                                if(this.inputFormat != '1'){
                                    detail.push(rr_date, rr_qty, rr_cost)
                                }
                                reportData.push(Object.assign({}, detail))

                                total_onhand_qty += Number(reportLine.onhand_qty)
                                grand_onhand_qty += Number(reportLine.onhand_qty)

                                if(this.inputFormat != '1'){
                                    total_in_qty += Number(reportLine.in_qty)
                                    total_out_qty += Number(reportLine.out_qty)
                                    total_available += available
                                    total_rr_qty += Number(reportLine.rr_qty)
                                    total_rr_cost += Number(reportLine.rr_cost)

                                    grand_in_qty += Number(reportLine.in_qty)
                                    grand_out_qty += Number(reportLine.out_qty)
                                    grand_available += available
                                    grand_rr_qty += Number(reportLine.rr_qty)
                                    grand_rr_cost += Number(reportLine.rr_cost)
                                }

                                if(i == this.birSalesReports.length-1){
                                    let sub_detail = ['', '', '']
                                    let grand_detail = ['', '', '']
                                    if(this.inputFormat == '1'){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }
                                    sub_detail.push(
                                        'Sub Total :',
                                        this.convertToCurrency(total_onhand_qty)
                                    )
                                    grand_detail.push(
                                        'Grand Total :',
                                        this.convertToCurrency(grand_onhand_qty)
                                    )
                                    if(this.inputFormat != '1'){
                                        sub_detail.push(
                                            this.convertToCurrency(total_in_qty),
                                            this.convertToCurrency(total_out_qty),
                                            this.convertToCurrency(total_available)
                                        )

                                        grand_detail.push(
                                            this.convertToCurrency(grand_in_qty),
                                            this.convertToCurrency(grand_out_qty),
                                            this.convertToCurrency(grand_available)
                                        )
                                    }
                                    if(this.inputFormat == '3'){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }
                                    if(this.inputFormat != '1'){
                                        sub_detail.push('', this.convertToCurrency(total_rr_qty), this.convertToCurrency(total_rr_cost))
                                        grand_detail.push('', this.convertToCurrency(grand_rr_qty), this.convertToCurrency(grand_rr_cost))
                                    }
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand_detail))
                                } else {
                                    let current_grouper = reportLine.grouper_id
                                    let next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        let sub_detail = ['', '', '']
                                        if(this.inputFormat == '1'){
                                            sub_detail.push('')
                                        }
                                        sub_detail.push(
                                            'Sub Total :',
                                            this.convertToCurrency(total_onhand_qty)
                                        )
                                        if(this.inputFormat != '1'){
                                            sub_detail.push(
                                                this.convertToCurrency(total_in_qty),
                                                this.convertToCurrency(total_out_qty),
                                                this.convertToCurrency(total_available)
                                            )
                                        }
                                        if(this.inputFormat == '3'){
                                            sub_detail.push('')
                                        }
                                        if(this.inputFormat != '1'){
                                            sub_detail.push('', this.convertToCurrency(total_rr_qty), this.convertToCurrency(total_rr_cost))
                                        }
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))

                                        total_onhand_qty = 0
                                        total_in_qty = 0
                                        total_out_qty = 0
                                        total_available = 0
                                        total_rr_qty = 0
                                        total_rr_cost = 0
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        let design_x = 340
                        let design_y = 200
                        if(this.inputFormat != 1) {
                            design_x = 400
                            design_y = 280
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"General Inventory Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(design_x,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(design_x,20,site_text,"right");
                        }
                        doc.text(15,25,"As of " + as_of)

                        let col_width_3 = 60
                        let col_width_4 = 30
                        if(this.inputFormat == '1'){
                            col_width_3 = 30
                            col_width_4 = 180
                        } else if(this.inputFormat == '2'){
                            col_width_3 = 90
                            col_width_4 = 30
                        }
                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 30},
                            2: {cellWidth: 30},
                            3: {cellWidth: col_width_3},
                            4: {cellWidth: col_width_4},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                            7: {cellWidth: 30},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30},
                            10: {cellWidth: 30},
                            11: {cellWidth: 30}
                        }

                        // console.log("------------")
                        // console.log("reportData",reportData)

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            margin: {bottom: 25},
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[4] == 'Grand Total :' || data.row.raw[3] == 'Sub Total :' || data.row.raw[4] == 'Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                        if(this.inputFormat != '1'){
                            var finalY = doc.lastAutoTable.finalY;
                            var legends = ['Available = On-Hand - Outgoing']
                            reportUtils.pdfTools.addLegend(doc, legends, finalY)
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "General Inventory Report" + group_text, design_x, design_y, i, pageCount)
                        }
                    }
                    

                    // window.open(URL.createObjectURL(doc.output("blob")))
                    doc.save(`General_Inventory_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                // console.log(this.inputSite);
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let sorting = this.inputSortBy
                if(this.inputFormat != '1'){
                    sorting = this.inputSortExtendedBy
                }

                let as_of = this.inputDate.format('MMMM DD, YYYY')

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "isTI": this.isConsider,
                    "isFormat": this.inputFormat,
                    "isPrev": this.isShowPrev,
                    "advanced_filter": this.params
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                // test
                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let header_top = [];
                    let site_specific = [];

                    if(this.inputFormat == '1'){
                        header_top.push('PCode','Barcode','Stock #','Ref Code','Description','On-Hand')
                        headers = header_top
                    } else {
                        header_top.push('PCode','Barcode','Stock #','Description','On-Hand','Incoming','Outgoing','Available')

                        if(this.inputFormat == '3'){
                            header_top.push('# of day/s\nsince last sale')
                        }

                        if(this.isConsider == true){
                            header_top.push('Last Arrival (RR/STI Document) - Date','Last Arrival (RR/STI Document) - Quantity','Last Arrival (RR/STI Document) - Cost')
                        }else{
                          header_top.push('Last Arrival (RR Document) - Date','Last Arrival (RR Document) - Quantity','Last Arrival (RR Document) - Cost')
                        }

                        headers = header_top
                    }

                    // console.log("-------------------")

                    for (let x=0; x < siteSpecific.length; x++){
                        // console.log("siteSpecific",siteSpecific);
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0
                            let total_in_qty = 0
                            let total_out_qty = 0
                            let total_rr_qty = 0
                            let total_rr_cost = 0
                            let total_available = 0

                            let grand_onhand_qty = 0
                            let grand_in_qty = 0
                            let grand_out_qty = 0
                            let grand_rr_qty = 0
                            let grand_rr_cost = 0
                            let grand_available = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(detail_header)
                                } else {
                                    if(grouper != reportLine.grouper_name){
                                        let detail_header = [grouper_name]
                                        reportData.push(detail_header)
                                    }
                                }
                                grouper = reportLine.grouper_name

                                let as_of_date = this.inputDate.format('YYYY-MM-DD')

                                let no_days_display = ''
                                if(reportLine.sales_date != null){
                                    let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                                    no_days_display = this.formatNumber(Number(no_days))
                                }

                                let rr_date = ''
                                let rr_qty = ''
                                let rr_cost = ''
                                if(reportLine.rr_date != null){
                                    rr_date = reportLine.rr_date
                                    rr_qty = this.convertToCurrency(Number(reportLine.rr_qty))
                                    rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                                }
                                let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)

                                let detail = [
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    reportLine.stock_no
                                ]
                                if(this.inputFormat == '1'){
                                    detail.push(reportLine.reference_code)
                                }
                                detail.push(reportLine.name,this.convertToCurrency(Number(reportLine.onhand_qty)))

                                if(this.inputFormat != '1'){
                                    detail.push(
                                        this.convertToCurrency(Number(reportLine.in_qty)),
                                        this.convertToCurrency(Number(reportLine.out_qty)),
                                        this.convertToCurrency(available)
                                    )
                                }
                                if(this.inputFormat == '3'){
                                    detail.push(no_days_display)
                                }
                                if(this.inputFormat != '1'){
                                    detail.push(rr_date, rr_qty, rr_cost)
                                }
                                reportData.push(detail)

                                total_onhand_qty += Number(reportLine.onhand_qty)
                                grand_onhand_qty += Number(reportLine.onhand_qty)

                                if(this.inputFormat != '1'){
                                    total_in_qty += Number(reportLine.in_qty)
                                    total_out_qty += Number(reportLine.out_qty)
                                    total_available += available
                                    total_rr_qty += Number(reportLine.rr_qty)
                                    total_rr_cost += Number(reportLine.rr_cost)

                                    grand_in_qty += Number(reportLine.in_qty)
                                    grand_out_qty += Number(reportLine.out_qty)
                                    grand_available += available
                                    grand_rr_qty += Number(reportLine.rr_qty)
                                    grand_rr_cost += Number(reportLine.rr_cost)
                                }

                                if(i == this.birSalesReports.length-1){
                                    let sub_detail = ['', '', '']
                                    let grand_detail = ['', '', '']
                                    if(this.inputFormat == '1'){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }
                                    sub_detail.push(
                                        'Sub Total :',
                                        this.convertToCurrency(total_onhand_qty)
                                    )
                                    grand_detail.push(
                                        'Grand Total :',
                                        this.convertToCurrency(grand_onhand_qty)
                                    )
                                    if(this.inputFormat != '1'){
                                        sub_detail.push(
                                            this.convertToCurrency(total_in_qty),
                                            this.convertToCurrency(total_out_qty),
                                            this.convertToCurrency(total_available)
                                        )

                                        grand_detail.push(
                                            this.convertToCurrency(grand_in_qty),
                                            this.convertToCurrency(grand_out_qty),
                                            this.convertToCurrency(grand_available)
                                        )
                                    }
                                    if(this.inputFormat == '3'){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }
                                    if(this.inputFormat != '1'){
                                        sub_detail.push('', this.convertToCurrency(total_rr_qty), this.convertToCurrency(total_rr_cost))
                                        grand_detail.push('', this.convertToCurrency(grand_rr_qty), this.convertToCurrency(grand_rr_cost))
                                    }
                                    reportData.push(["---"])
                                    reportData.push(sub_detail)

                                    reportData.push(["---"])
                                    reportData.push(grand_detail)
                                } else {
                                    let current_grouper = reportLine.grouper_id
                                    let next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        let sub_detail = ['', '', '']
                                        if(this.inputFormat == '1'){
                                            sub_detail.push('')
                                        }
                                        sub_detail.push(
                                            'Sub Total :',
                                            this.convertToCurrency(total_onhand_qty)
                                        )
                                        if(this.inputFormat != '1'){
                                            sub_detail.push(
                                                this.convertToCurrency(total_in_qty),
                                                this.convertToCurrency(total_out_qty),
                                                this.convertToCurrency(total_available)
                                            )
                                        }
                                        if(this.inputFormat == '3'){
                                            sub_detail.push('')
                                        }
                                        if(this.inputFormat != '1'){
                                            sub_detail.push('', this.convertToCurrency(total_rr_qty), this.convertToCurrency(total_rr_cost))
                                        }
                                        reportData.push(["-----"])
                                        reportData.push(sub_detail)

                                        total_onhand_qty = 0
                                        total_in_qty = 0
                                        total_out_qty = 0
                                        total_available = 0
                                        total_rr_qty = 0
                                        total_rr_cost = 0
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        if(this.isSeparateSite == true){
                            reportData.push([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }

                        if(this.inputFormat != '1'){
                            var legends = ['Available = On-Hand - Outgoing']
                            reportData = reportUtils.csvxlsxTools.addLegend(reportData, legends)
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["General Inventory Report" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
										}
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>
